import EmblaCarousel from 'embla-carousel';
import { setupPrevNextBtns, disablePrevNextBtns } from '../helpers/carousel-buttons';

(() => {
  const testimonialCarousel = document.querySelectorAll('.m08');
  const options = {
    loop: true,
    draggable: window.outerWidth < 1040
  };

  testimonialCarousel.forEach(carousel => {
    const viewport = carousel.querySelector('.m08__wrapper');

    if (viewport === null) {
      return;
    }

    const embla = EmblaCarousel(viewport, options);

    const prevBtn = carousel.querySelector('.m08__button--prev');
    const nextBtn = carousel.querySelector('.m08__button--next');
    const disablePrevAndNextBtns = disablePrevNextBtns(prevBtn, nextBtn, embla);

    setupPrevNextBtns(prevBtn, nextBtn, embla);

    embla.on('select', disablePrevAndNextBtns);
    embla.on('init', disablePrevAndNextBtns);
  });
})();
